import logo from "./logo.svg";
import "./App.css";
import { useState, useEffect } from "react";
import { supabase } from "./SupabaseClient";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import ExpenseForm from "./ExpenseForm.js";
import ExpenseList from "./ExpenseList.js";
import LandingPage from "./LandingPage.js";
import Register from "./Register.js";
import Login from "./Login.js";

function App() {
  const [expenses, setExpense] = useState([]);
  const [sum, setSum] = useState(0);
  const [user, setUser] = useState(null);

  const AddExpense = (expense) => {
    setExpense([...expenses, expense]);
  };
  useEffect(() => {
    const getSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
    };

    getSession();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user ?? null);
        if (!session) setExpense([]); // clear expenses on logout
      },
    );
    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  const total = expenses.reduce((sum, expense) => {
    return sum + Number(expense.amount);
  }, 0);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/Login" element={<Login />} />
          <Route
            path="/ExpenseForm"
            element={<ExpenseForm passExpense={AddExpense} />}
          />
        </Routes>
      </BrowserRouter>

      {expenses.length > 0 && <ExpenseList expenses={expenses} total={total} />}
    </div>
  );
}

export default App;
